import { getHandler, patchHandler, postHandler } from 'src/utils/fetchHandler';
import {
	getPendingBlackbaudUserUpdate,
	getPendingBlackbaudUserCreate,
} from './blackbaudUser.selector';

export const CLEAR_BLACKBAUD_USERS = 'CLEAR_BLACKBAUD_USERS/BLACKBAUD_USER/@WISELY/WEB';
export const CLEAR_BLACKBAUD_USER_UPDATE_ERRORS =
	'CLEAR_BLACKBAUD_USER_UPDATE_ERRORS/BLACKBAUD_USER/@WISELY/WEB';
export const CLEAR_BLACKBAUD_USER_CREATE_ERRORS =
	'CLEAR_BLACKBAUD_USER_CREATE_ERRORS/BLACKBAUD_USER/@WISELY/WEB';
export const GET_BLACKBAUD_USER = 'GET_BLACKBAUD_USER/BLACKBAUD_USER/@WISELY/WEB';
export const GET_BLACKBAUD_USERS = 'GET_BLACKBAUD_USERS/BLACKBAUD_USER/@WISELY/WEB';
export const FETCH_BLACKBAUD_USER_FAILED = 'FETCH_BLACKBAUD_USER_FAILED/BLACKBAUD_USER/@WISELY/WEB';
export const FETCH_BLACKBAUD_USER_SUCCEEDED =
	'FETCH_BLACKBAUD_USER_SUCCEEDED/BLACKBAUD_USER/@WISELY/WEB';
export const FETCH_BLACKBAUD_USERS_FAILED =
	'FETCH_BLACKBAUD_USERS_FAILED/BLACKBAUD_USER/@WISELY/WEB';
export const FETCH_BLACKBAUD_USERS_SUCCEEDED =
	'FETCH_BLACKBAUD_USERS_SUCCEEDED/BLACKBAUD_USER/@WISELY/WEB';
export const UPDATE_BLACKBAUD_USER = 'UPDATE_BLACKBAUD_USER/BLACKBAUD_USER/@WISELY/WEB';
export const UPDATE_BLACKBAUD_USER_FAILED =
	'UPDATE_BLACKBAUD_USER_FAILED/BLACKBAUD_USER/@WISELY/WEB';
export const UPDATE_BLACKBAUD_USER_SUCCEEDED =
	'UPDATE_BLACKBAUD_USER_SUCCEEDED/BLACKBAUD_USER/@WISELY/WEB';
export const CREATE_BLACKBAUD_USER = 'CREATE_BLACKBAUD_USER/BLACKBAUD_USER/@WISELY/WEB';
export const CREATE_BLACKBAUD_USER_FAILED =
	'CREATE_BLACKBAUD_USER_FAILED/BLACKBAUD_USER/@WISELY/WEB';
export const CREATE_BLACKBAUD_USER_SUCCEEDED =
	'CREATE_BLACKBAUD_USER_SUCCEEDED/BLACKBAUD_USER/@WISELY/WEB';

export const clearBlackbaudUsers = () => ({
	type: CLEAR_BLACKBAUD_USERS,
});

export const clearBlackbaudUserUpdateErrors = () => ({
	type: CLEAR_BLACKBAUD_USER_UPDATE_ERRORS,
});

export const clearBlackbaudUserCreateErrors = () => ({
	type: CLEAR_BLACKBAUD_USER_CREATE_ERRORS,
});

export const getBlackbaudUser = () => ({
	type: GET_BLACKBAUD_USER,
});

export const getBlackbaudUsers = () => ({
	type: GET_BLACKBAUD_USERS,
});

export const fetchBlackbaudUserFailed = payload => ({
	type: FETCH_BLACKBAUD_USER_FAILED,
	payload,
});

export const fetchBlackbaudUserSucceeded = payload => ({
	type: FETCH_BLACKBAUD_USER_SUCCEEDED,
	payload,
});

export const fetchBlackbaudUsersFailed = payload => ({
	type: FETCH_BLACKBAUD_USERS_FAILED,
	payload,
});

export const fetchBlackbaudUsersSucceeded = payload => ({
	type: FETCH_BLACKBAUD_USERS_SUCCEEDED,
	payload,
});

export const fetchBlackbaudUser = (id, params) => {
	return dispatch => {
		dispatch(getBlackbaudUser());
		const path = `v1/blackbaud_users/${id}`;

		return getHandler(path, params)
			.then(json => dispatch(fetchBlackbaudUserSucceeded(json)))
			.catch(error => {
				console.error('fetchBlackbaudUser error', error);
				dispatch(fetchBlackbaudUserFailed());
			});
	};
};

export const fetchBlackbaudUsers = params => {
	return async dispatch => {
		dispatch(getBlackbaudUsers());
		const path = 'v1/blackbaud_users';

		return getHandler(path, params)
			.then(json => dispatch(fetchBlackbaudUsersSucceeded(json)))
			.catch(error => {
				console.error('fetchBlackbaudUsers error', error);
				dispatch(fetchBlackbaudUsersFailed(error));
			});
	};
};

export const updateBlackbaudUser = () => ({
	type: UPDATE_BLACKBAUD_USER,
});

export const requestUpdateBlackbaudUserFailed = payload => ({
	type: UPDATE_BLACKBAUD_USER_FAILED,
	payload,
});

export const requestUpdateBlackbaudUserSucceeded = payload => ({
	type: UPDATE_BLACKBAUD_USER_SUCCEEDED,
	payload,
});

export const requestUpdateBlackbaudUser = (id, body) => {
	return async (dispatch, getState) => {
		if (getPendingBlackbaudUserUpdate(getState())) {
			return;
		}
		dispatch(updateBlackbaudUser());
		const path = `v1/blackbaud_users/${id}`;

		return patchHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestUpdateBlackbaudUserSucceeded(json)))
			.catch(error => {
				console.error('requestUpdateBlackbaudUser error', error);
				dispatch(requestUpdateBlackbaudUserFailed(error));
			});
	};
};

export const createBlackbaudUser = () => ({
	type: CREATE_BLACKBAUD_USER,
});

export const requestCreateBlackbaudUserFailed = payload => ({
	type: CREATE_BLACKBAUD_USER_FAILED,
	payload,
});

export const requestCreateBlackbaudUserSucceeded = payload => ({
	type: CREATE_BLACKBAUD_USER_SUCCEEDED,
	payload,
});

export const requestCreateBlackbaudUser = body => {
	return async (dispatch, getState) => {
		if (getPendingBlackbaudUserCreate(getState())) {
			return;
		}
		dispatch(createBlackbaudUser());
		const path = `v1/blackbaud_users`;

		return postHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestCreateBlackbaudUserSucceeded(json)))
			.catch(error => {
				console.error('requestCreateBlackbaudUser error', error);
				dispatch(requestCreateBlackbaudUserFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/blackbaudUsers/blackbaudUser.action.js